import { render } from "./AccountOrderDetailsBackorderedGrid.vue?vue&type=template&id=1385aabf"
import script from "./AccountOrderDetailsBackorderedGrid.vue?vue&type=script&lang=js"
export * from "./AccountOrderDetailsBackorderedGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__